<div class="panel-options-body">
    <div class="form form-horizontal">
        <div class="form-row">
            <div class="form-group" [class.mb-10]="availablePaymentMethods()?.[type()]">
                <div class="type-dropdown-default col-xs-12" dropdown>
                    <button class="btn btn-default dropdown-toggle custom-btn" data-toggle="dropdown" dropdownToggle>
                        <div class="strip-text">
                            <img [src]="getPaymentIconSrc(type())" [alt]="type()" />
                            <span class="strip-text">{{ paymentsList()[type()]?.label | translate }}</span>
                        </div>
                        <span class="caret"></span>
                    </button>

                    <ul class="dropdown-menu" *dropdownMenu>
                        @for (payment of paymentsList() | keyvalue: paymentIndexOrder; track payment) {
                            @if (!payment.value.hidden) {
                                <li [class.hide]="type() === payment.value.type" (click)="setType(payment.value.type)">
                                    <img
                                        [src]="getPaymentIconSrc(payment.value.type)"
                                        [alt]="payment.value.label | translate"
                                    />
                                    <span>{{ payment.value.label | translate }}</span>
                                </li>
                            }
                        }
                    </ul>

                    @if (availablePaymentMethods()?.[type()] === false) {
                        <div class="help-block small">
                            <span class="sp-icon icon-warning color-warning"> </span>
                            {{ "payment_method_is_not_active" | translate }}
                            <a class="dashed" href="/settings/#payment-systems" target="_blank">{{
                                "enable" | translate
                            }}</a>
                        </div>
                    }
                </div>
            </div>

            @if (availablePaymentMethods()?.[type()] && paymentMethodsByType()?.length > 1) {
                <div class="form-group mb-10">
                    <div class="type-dropdown-default col-xs-12" dropdown>
                        <button
                            class="btn btn-default dropdown-toggle custom-btn"
                            data-toggle="dropdown"
                            dropdownToggle
                        >
                            <div class="strip-text">
                                <span class="strip-text">{{ paymentMethodByType()?.name }}</span>
                            </div>
                            <span class="caret"></span>
                        </button>
                        <ul class="dropdown-menu chat-bots-dropdown" *dropdownMenu>
                            @for (payment of paymentMethodsByType(); track payment) {
                                <li
                                    [class.selected]="paymentMethodId() === payment.id"
                                    (click)="setPaymentMethodId(payment)"
                                >
                                    <span>{{ payment.name }}</span>
                                </li>
                            }
                        </ul>
                    </div>
                </div>
            }
            @if (isCustomPaymentType()) {
                <div class="form-group" [class.has-error]="isCustomPaymentNameInvalid()">
                    <div class="col-xs-12">
                        <label class="control-label">
                            {{ "control_custom_payment_label" | translate }}
                        </label>
                        <span class="help-block small">
                            {{ "control_custom_payment_label_hint" | translate }}
                        </span>
                    </div>
                    <div class="col-xs-12">
                        <input
                            type="text"
                            class="form-control"
                            placeholder="{{ 'custom_payment_label' | translate }}"
                            [formField]="field().customPaymentName"
                        />
                        @if (isCustomPaymentNameInvalid()) {
                            <span class="help-block small">
                                {{ "control_errors_required" | translate }}
                            </span>
                        }
                    </div>
                </div>
            }

            @if (!isCustomPaymentType()) {
                <div class="form-group">
                    <div class="col-xs-12">
                        <label class="control-label">
                            {{ "control_custom_payment_label" | translate }}
                        </label>
                        <span class="help-block small">
                            {{ "control_custom_payment_label_hint" | translate }}
                        </span>
                    </div>
                    <div class="col-xs-12">
                        <input
                            type="text"
                            class="form-control"
                            placeholder="{{ 'custom_payment_label' | translate }}"
                            [formField]="field().newPaymentName"
                        />
                    </div>
                </div>
            }

            @if (availablePaymentMethods()?.[type()] && !shopCurrency()) {
                <div class="form-group">
                    <div [class.col-xs-6]="isCustomPaymentType()" [class.col-xs-7]="!isCustomPaymentType()">
                        <select class="form-control" (change)="onIsEditableTotalCostChange($event)">
                            <option [value]="false" [selected]="!isEditableTotalCost()">
                                {{ "control_indicated_price" | translate }}
                            </option>
                            <option [value]="true" [selected]="isEditableTotalCost()">
                                {{ "control_minimal_price" | translate }}
                            </option>
                        </select>
                    </div>
                    <div
                        [class.col-xs-6]="isCustomPaymentType()"
                        [class.col-xs-5]="!isCustomPaymentType()"
                        [class.has-error]="isAmountInvalid()"
                    >
                        @if (isCustomPaymentType()) {
                            <sp-input-num
                                [min]="amountConfig.min"
                                [max]="amountConfig.max"
                                [step]="amountConfig.step"
                                placeholder="0.00"
                                [value]="amount()"
                                (valueChange)="setAmount($event)"
                                [suffixList]="paymentCurrenciesList"
                                [suffixValue]="currency()"
                                (suffixChangeEvent)="setCurrency($event)"
                            />
                        } @else {
                            <sp-input-num
                                [min]="amountConfig.min"
                                [max]="amountConfig.max"
                                [step]="amountConfig.step"
                                placeholder="0.00"
                                [suffixText]="currency()"
                                [value]="amount()"
                                (valueChange)="setAmount($event)"
                            />
                        }
                    </div>
                    @if (isCryptomusPaymentType()) {
                        <div class="col-xs-12 help-block small">
                            {{ "help_text_cryptomus" | translate }}
                        </div>
                    }
                </div>
            }

            @if (type() === EPaymentType.liqpay && availablePaymentMethods()?.[type()] && showRroSettings()) {
                <div class="form-group" [class.mb-10]="rroIsActive()">
                    <label class="control-label col-xs-10">
                        {{ "liqpay_rro_label" | translate }}
                        <span
                            class="small sp-icon icon-question color-light hover-effect"
                            [popover]="ppoTooltip"
                            [outsideClick]="true"
                            triggers="mouseenter"
                        ></span>
                        <ng-template #ppoTooltip>
                            <span>{{ "liqpay_rro_help" | translate }}</span>
                            <br />
                            <a [href]="rroLiqHelpLink" target="_blank"
                                >{{ "ligpay_rro_help_link" | translate }}
                                <small class="sp-icon icon-outgoing small-xs color-light"></small
                            ></a>
                        </ng-template>
                    </label>
                    <div class="col-xs-2 control-switch text-right">
                        <sp-switch [active]="rroIsActive()" (toggleActiveEvent)="setRroIsActive($event)" />
                    </div>
                </div>
                @if (rroIsActive()) {
                    <div class="form-group">
                        <div class="col-xs-12">
                            <div class="input-group" [class.has-error]="isRroIdInvalid()">
                                <span class="input-group-addon" id="liqpay-id">{{ "liqpay_rro_id" | translate }}</span>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="123456"
                                    aria-describedby="liqpay-id"
                                    [value]="rroId()"
                                    (input)="setRroId($event)"
                                />
                            </div>
                            @if (isRroIdInvalid()) {
                                <small class="text-error">
                                    {{ "control_errors_required" | translate }}
                                </small>
                            }
                        </div>
                    </div>
                }
            }
            @if (type() === EPaymentType.monobank && availablePaymentMethods()?.[type()] && showRroSettings()) {
                <div class="form-group" [class.mb-10]="rroIsActive()">
                    <label class="control-label col-xs-10">
                        {{ "liqpay_rro_label" | translate }}
                        <span
                            class="small sp-icon icon-question color-light hover-effect"
                            [popover]="ppoTooltip"
                            [outsideClick]="true"
                            triggers="mouseenter"
                        ></span>
                        <ng-template #ppoTooltip>
                            <span>{{ "liqpay_rro_help" | translate }}</span>
                            <br />
                        </ng-template>
                    </label>
                    <div class="col-xs-2 control-switch text-right">
                        <sp-switch [active]="rroIsActive()" (toggleActiveEvent)="setRroIsActive($event)" />
                    </div>
                </div>
                @if (rroIsActive()) {
                    <div class="form-group">
                        <div class="col-xs-12">
                            <div class="input-group" [class.has-error]="isRroIdInvalid()">
                                <span class="input-group-addon" id="mono-id">{{ "liqpay_rro_id" | translate }}</span>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="123456"
                                    aria-describedby="mono-id"
                                    [value]="rroId()"
                                    (input)="setRroId($event)"
                                />
                            </div>
                            @if (isRroIdInvalid()) {
                                <small class="text-error">
                                    {{ "control_errors_required" | translate }}
                                </small>
                            }
                        </div>
                    </div>
                }
            }
            @if (isCustomPaymentType()) {
                <div class="form-group">
                    <div class="col-xs-12">
                        <div class="alert alert-info-mutted alert-sm">
                            {{ "custom_payment_notify" | translate }}
                        </div>
                    </div>
                </div>
            }
        </div>
    </div>
</div>
